import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { PmiButton } from 'shell/components/shared/button';
import { useState, memo } from 'react';
import { FormikProps } from 'formik';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';
import { FiltersFormRegisterCertification } from 'front-office/view-models/register-certification-list';

interface FiltersProps {
  filterRegisterCertificationForm: FormikProps<FiltersFormRegisterCertification>;
}

const FilterRegisterCertificationComponent = ({
  filterRegisterCertificationForm,
}: FiltersProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-feature-auth-content"
        id="panel-feature-auth-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterRegisterCertificationForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Tipo registro"
                label="Tipo registro"
                id="type"
                name="type"
                fullWidth
                type="text"
                variant="outlined"
                value={filterRegisterCertificationForm.values.type}
                onChange={filterRegisterCertificationForm.handleChange}
                inputProps={{
                  maxLength: '8',
                }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <PmiTextField
                aria-label="Sigla registro"
                label="Sigla registro"
                id="initials"
                name="initials"
                fullWidth
                type="text"
                variant="outlined"
                value={filterRegisterCertificationForm.values.initials}
                onChange={filterRegisterCertificationForm.handleChange}
                inputProps={{
                  maxLength: '1',
                }}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <PmiTextField
                aria-label="Descrizione registro"
                label="Descrizione registro"
                id="description"
                name="description"
                fullWidth
                type="text"
                variant="outlined"
                value={filterRegisterCertificationForm.values.description}
                onChange={filterRegisterCertificationForm.handleChange}
                inputProps={{
                  maxLength: '50',
                }}
              />
            </Grid>
            <Grid item>
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterRegisterCertificationForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FilterRegisterCertificationComponent.displayName = 'Filters Register Certification component';

const FilterRegisterCertification = memo(FilterRegisterCertificationComponent);

export default FilterRegisterCertification;
